// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header__Header___1_1R8","Title":"Header__Title___3cHrR","Logo":"Header__Logo___1xqts","root":"Header__root___14IZ-"};